import { environment } from 'src/environments/environment';

export const httpVersion = {
  PORTAL_V1: environment.API_URL + 'webapi/v1/portal/',
  V1: environment.API_URL + 'webapi/v1/',
  SUPERADMIN_V1: environment.API_URL + 'webapi/v1/superadmin/',
};

export enum httpRoutes {
  
  // auth
  GET_COMPANY_SETTINGS = 'getcompanysetting',
  USER_LOGIN = 'login',
  GET_USER_COMPANY = 'getlogincompanylist',
  GET_MY_COMPANY_LIST = 'getmycompanylist',
  SEND_OTP_EMAIL = 'sendemailotp',
  EMAIL_FORGET_PASSWORD = 'emailforgotpassword',
  SEND_EMAIL_FORGET_PASSWORD = 'sendemailforgotpassword',
  SUBMITT_OTP = 'submitemailotp',
  LOGIN_WITH_OTP = 'loginwithemailotp',
  CHANGEPASSWORD = 'changepassword',
  USER_LOGIN_HISTORY = 'savelogindetails',

  // Ticket system
  PORTAL_TICKET_GET_TABLE = "getticketfortable",
  PORTAL_GET_ALL_STATUS_COUNT = 'countStatus',
  GET_ONE_TICKET_PORTAL = 'getoneicket',
  SAVE_PORTAL_TICKET = 'addTicketSystem',



  // Dashboard
  GET_DASHBOARD_INVOICE = 'getdashboardinvoice',
  GET_DASHBOARD_INVOICE_COUNTS = 'getdashboardcount',
  DASHBOARD_INVOICE_FOR_TABLE = 'dashboardInvoiceListForTable',
  DASHBOARD_MONTHLY_INVOICE_CHART = 'getdashboardmonthlyinvoicechart',
  DASHBOARD_MONTHLY_HISTORY_CHART = 'getdashboardmonthlyhistorychart',
  GET_DUPLICATE_DOCUMENT_FOR_TABLE = 'getduplicatedocumentsfortable',
  GET_DASHBOARD_JOB_COST = 'getdashboardjobcost',
  // Vendor
  PORTAL_VENDOR_GET_FOR_TABLE = 'getvendorfortable',
  PORTAL_VENDOR_LOCATION_GET_FOR_TABLE = 'getvendorLocationsfortable',
  PORTAL_VENDOR_LOCATION_SAVE = 'saveVendorLocation',
  PORTAL_VENDOR_LOCATION_GET = 'getOneVendorLocation',
  PORTAL_VENDOR_GET_ONE = 'getonevendor',
  PORTAL_VENDOR_SAVE = 'savevendor',
  PORTAL_VENDOR_STATUS_UPDATE = 'vendorStatusUpdate',
  PORTAL_VENDOR_DELETE = 'deletevendor',
  PORTAL_VENDOR_GET_HISTORY = 'getvendorhistory',
  PORTAL_VENDOR_REPORT = 'getvendorreport',
  PORTAL_VENDOR_ALL_DELETE = 'deleteMultipleVendor',
  PORTAL_ALL_VENDOR_STATUS_UPDATE = 'updateMultipleVendorStatus',
  PORTAL_VENDOR_GET = 'getvendor',
  IMPORT_CHECK_VENDOR = 'checkImportVendor',
  IMPORT_VENDOR = 'importVendor',
  PORTAL_GRID_VENDOR_GET = 'getvendorall',

  // Terms
  PORTAL_TERM_GET = 'getinvoiceterm',
  PORTAL_TERM_SAVE = 'saveinvoiceterm',
  PORTAL_TERM_DELETE = 'deleteinvoiceterm',
  PORTAL_TERM_ALL_DELETE = 'deleteMultipleTeamMember',
  PORTAL_ALL_USER_STATUS_CHANGE = 'updateMultipleUserStatus',
  PORTAL_USER_STATUS_UPDATE = 'updateUserStatus',
  GET_COMPANY_INFO = 'companyInformation',
  SAVE_COMPANY_INFO = 'editcompany',
  // PORTAL_ROVUK_SPONSOR_GET_PRIME_WORK_PERFORMED = 'getsupplierprimeworkperformed',
  // PORTAL_ROVUK_SPONSOR_GET_CSIDIVISION_WORK_PERFORMED = 'getcsidivision',
  // Attachment
  PORTAL_SAVE_ATTACHMENT = 'saveAttachment',
  CHECK_APPROVER = 'checkApproverUser',

  // User
  PORTAL_USER_GET_FOR_TABLE = 'getUserForTable',
  USER_DELETE = 'deleteteammember',
  USER_SETTING_ROLES_ALL = 'getallrolespermission',
  USER_RECOVER = 'recoverteam',
  USER_HISTORY = 'getuserhistory',
  USER_REPORT = 'getallemployeereport',
  TEAM_HISTORY = 'getuserhistory',
  GET_ALL_USER = 'getalluser',
  GET_SPECIFIC_USERS = 'getspecificusers',
  GET_USER_PROFILE = 'getprofile',
  GET_ONE_USER = 'getoneuser',
  //GET_LOCATION = 'getalllocation',
  GET_JOB_TITLE = 'getAlljobtitle',
  GET_JOB_TYPE = 'getAlljobtype',
  GET_DOCUMENT_TYPE = 'getalldoctype',
  GET_LANGUAGE = 'getlanguage',
  GET_DEPARTMENT = 'getalldepartment',
  SAVE_USER = 'saveemployee',
  SAVE_USER_PERSONAL_INFO = 'savepersonalinfo',
  SAVE_USER_CONTACT_INFO = 'savecontactinfo',
  SAVE_USER_INFO = 'saveemployeeinfo',
  SAVE_USER_MOBILE_PIC = 'savemobilephoto',
  SAVE_USER_PASSWORD = 'senduserpassword',
  USER_SEND_INVITATION = 'sendappinvitation',

  // Emergency Contact
  GET_EMERGENCY_CONTACT = 'getemergencycontact',
  GET_ONE_EMERGENCY_CONTACT = 'getoneemergencycontact',
  SAVE_EMERGENCY_CONTACT = 'saveemergencycontact',
  DELETE_EMERGENCY_CONTACT = 'deleteemergencycontact',
  GET_RELATIONSHIP = 'getallrelationships',

  // User Document
  GET_USER_DOCUMENT = 'getuserdocument',
  GET_ONE_USER_DOCUMENT = 'getoneuserdocument',
  SAVE_USER_DOCUMENT = 'saveuserdocument',
  EDIT_USER_DOCUMENT = 'edituserdocument',
  DELETE_USER_DOCUMENT = 'deleteuserdocument',

  //Mail box
  MAILBOX_DATA_TABLE = 'getMailboxMonitorForTable',
  SAVE_MAILBOX = 'savemailboxmonitor',
  VERIFY_MAILBOX = 'verifyIMAP',
  GET_ONE_MAILBOX = 'getonemailboxmonitor',
  DELETE_MAILBOX = 'deletemailboxmonitor',
  GET_MAILBOX = 'getallmailboxmonitor',

  //SMTP
  GET_COMPANY_SMTP = 'companysmtp',
  VERIFY_SMTP = 'companyverifysmtp',
  SAVE_SMTP = 'companyupdatesmtp',

  //employee
  SETTINGS_CHECK_IMPORT__DOCUMENT_TYPE = 'checkimportdoctype',
  SETTINGS_IMPORT_DOCUMENT_TYPE = 'importdoctype',
  SETTING_DOCUMENT_TYPE_DATA_TABLE = 'getdoctypefortable',
  SETTING_DOCUMENT_TYPE_GET = 'getalldoctype',
  SETTING_DOCUMENT_TYPE_DELETE = 'deletedoctype',
  SETTING_DOCUMENT_TYPE_SAVE = 'savedoctype',
  SETTINGS_CHECK_IMPORT_DEPARTMENTS = 'checkimportdepartment',
  SETTINGS_IMPORT_DEPARTMENTS = 'importdepartment',
  SETTING_DEPARTMENTS_DATA_TABLE = 'getdepartmentfortable',
  SETTING_DEPARTMENTS_GET = 'getalldepartment',
  SETTING_DEPARTMENTS_DELETE = 'deletedepartment',
  SETTING_DEPARTMENTS_SAVE = 'savedepartment',
  SETTINGS_CHECK_IMPORT_JOB_TITLE = 'checkimportjobtitle',
  SETTINGS_IMPORT_JOB_TITLE = 'importjobtitle',
  SETTING_JOB_TITLE_DATA_TABLE = 'getjobtitlefortable',
  SETTING_JOB_TITLE_ALL = 'getAlljobtitle',
  SETTING_JOB_TITLE_DELETE = 'deletejobtitle',
  SETTING_JOB_TITLE_SAVE = 'savejobtitle',
  SETTINGS_CHECK_IMPORT_JOB_TYPE = 'checkimportjobtype',
  SETTINGS_IMPORT_JOB_TYPE = 'importjobtype',
  SETTING_JOB_TYPE_DATA_TABLE = 'getjobtypefortable',
  SETTING_JOB_TYPE_ALL = 'getAlljobtype',
  SETTING_JOB_TYPE_DELETE = 'deletejobtype',
  SETTING_JOB_TYPE_SAVE = 'savejobtype',
  SETTINGS_CHECK_IMPORT_RELATIONSHIP = 'checkimportrelationship',
  SETTINGS_IMPORT_RELATIONSHIP = 'importrelationship',
  SETTING_RELATIONSHIP_DATA_TABLE = 'getrelationshipfortable',
  SETTING_RELATIONSHIP_ALL = 'getallrelationships',
  SETTING_RELATIONSHIP_DELETE = 'deleterelationship',
  SETTING_RELATIONSHIP_SAVE = 'saverelationship',
  SETTINGS_IMPORT_LANGUAGE = 'importlanguage',
  SETTINGS_CHECK_IMPORT_LANGUAGE = 'checkimportlanguage',
  OTHER_LANGUAGE_DATA_TABLE = 'getlanguageForTable',
  OTHER_LANGUAGE_GET = 'getlanguage',
  OTHER_LANGUAGE_DELETE = 'deletelanguage',
  OTHER_LANGUAGE_SAVE = 'savelanguage',

  //other settings
  TERMS_DATA_TABLE = 'gettermfortable',
  OTHER_SETTINGS_GET_TERMS = 'getinvoiceterm',
  OTHER_SETTING_SAVE_TERMS = 'saveinvoiceterm',
  OTHER_SETTING_DELETE_TERMS = 'deleteinvoiceterm',
  OTHER_SETTINGS_IMPORT_TERMS = 'importterm',
  OTHER_SETTINGS_CHECK_IMPORT_TERMS = 'checkimportterm',
  VENDOR_TYPE_DATA_TABLE = 'getvendortypefortable',
  OTHER_SETTINGS_GET_VENDOR_TYPE = 'getvendortype',
  OTHER_SETTINGS_SAVE_VENDOR_TYPE = 'savevendortype',
  OTHER_SETTINGS_DELETE_VENDOR_TYPE = 'deletevendortype',
  OTHER_SETTINGS_IMPORT_VENDOR_TYPE = 'importvendortype',
  OTHER_SETTINGS_CHECK_IMPORT_VENDOR_TYPE = 'checkimportvendortype',

  //DOCUMENTS_DATA_TABLE = 'getInvoiceDocumentForTable',
  //OTHER_SETTINGS_GET_DOCUMENT = 'getinvoicedocument',
  //OTHER_SETTING_SAVE_DOCUMENT = 'saveinvoicedocument',
  //OTHER_SETTING_DELETE_DOCUMENT = 'deleteInvoiceDocument',
  //OTHER_SETTINGS_IMPORT_DOCUMENT = 'importinvoicedocument',
  //OTHER_SETTINGS_CHECK_IMPORT_DOCUMENT = 'checkimportinvoicedocument',
  OTHER_SETTINGS_CHECK_IMPORT_CLASS = 'checkimportclassname',
  OTHER_SETTINGS_IMPORT_CLASS = 'importclassname',

  GET_CLASS_NAME = 'getclassname',
  CLASS_NAME_DATA_TABLE = 'getclassnameForTable',
  SAVE_CLASS_NAME = 'saveclassname',
  DELETE_CLASS_NAME = 'deleteclassname',

  // Document_View
  INVOICE_OTHER_SETTING_UPDATE_ALERTS = 'getupdatesetting',
  PORTAL_SMARTACCUPAY_INVOICE__SETTINGS_GET_ALL_ALERTS = 'getallsetting',
  GET_LATEST_CORRENCY_RATES = 'getcurrencyrate',

  // Report
  INVOICE_FOR_REPORT = 'getinvoiceforreport',

  //security
  PORTAL_SETTING_GET = 'getallsetting',
  PORTAL_SETTING_UPDATE = 'getupdatesetting',
  CLEAN_INVOICE_DB = 'clean_invoice_db',

  //Alerts
  PORTAL_SMARTACCUPAY_INVOICE_OTHER_SETTING_UPDATE_ALERTS = 'getupdatesetting',
  PORTAL_SETTING_ROLES_ALL = 'getallrolespermission',
  PORTAL_GET_ALL_USERS = 'getalluser',
  IMPORT_USER = 'checkandinsertimportdata',
  CHECK_IMPORT_USER = 'importemployees',
  // DOCUMENT
  DOCUMENTS_DATATABLE = 'getViewDocumentsDatatableForTable',

  //costcode
  SETTINGS_CHECk_IMPORT_COSTCODE_DATA = 'checkimportcostcode',
  SETTINGS_IMPORT_COSTCODE_DATA = 'importCostCode',
  COSTCODE_DATA_TABLE = 'getCostCodeForTable',
  DELETE_COST_CODE = 'deletecostcode',
  COST_CODE_SAVE = 'savecostcode',
  GET_COST_CODE = 'getallcostcode',

  //usage
  USAGE_DATA_TABLE = 'getCustomerStates',
  PORTAL_SETTING_USEAGE = 'companyUsage',
  GET_API_COUNT = 'getapicount',
  GET_INVOICE_COUNT_FOR_FREE_TRIAL = 'getInvoiceCountForFreeTrial',

  //role
  SETTING_ROLES_ALL = 'getallrolespermission',
  SETTING_ROLES_SAVE = 'saveRoles',

  //clients
  GET_ALL_COSTCODE = 'getCostCode',
  SAVE_CLIENT = 'saveclient',
  GET_CLIENT = 'getclient',
  CLIENT_DATA_TABLE = 'getClientForTable',
  CLIENT_UPDATE_ALL_STATUS = 'updateMultipleClientStatus',
  CLIENT_DELETE = 'deleteclient',
  CLIENT_GET_ONE = 'getOneClient',
  CLIENT_UPDATE_STATUS = 'updateClientStatus',
  CLIENT_ALL_DELETE = 'deleteMultipleClient',
  CLIENT_GET_HISTORY = 'getClientHistory',
  CHECK_IMPORT_CLIENT = 'checkimportclient',
  IMPORT_CLIENT = 'importclient',

  // Invoice Message
  GET_INVOICE_MESSAGE_COUNT = 'getinvoicemessagecount',
  GET_INVOICE_MESSAGE_FOR_TABLE = 'getinvoicemessagefortable',
  GET_ONE_INVOICE_MESSAGE = 'getoneinvoicemessage',
  UPDATE_INVOICE_MESSAGE_SEEN_FLAG = 'updateinvoicemessageseenflag',
  SEND_INVOICE_MESSAGE = 'sendinvoicemessage',
  DELETE_INVOICE_MESSAGE = 'deleteinvoicemessage',

  //mail
  SEND_INVOICE_EMAIL = 'sendInvoiceEmail',

  // Invoice
  INVOICE_SAVE_INVOICE_PROCESS = "saveinvoiceprocess",
  GET_INVOICE_FOR_TABLE = 'getapinvoicefortable',
  GET_SIDEBAR_INVOICE_COUNT = 'getSidebarInvoiceCount',
  GET_VENDOR_BASED_INVOICE = 'getapvendorbasedinvoice',
  GET_ONE_INVOICE = 'getoneapinvoice',
  SAVE_INVOICE = 'saveapinvoice',
  GENERATE_PRESIGNED_URL = 'generateSignedURLForPDF',
  SAVE_OTHER_DOCUMENT_INVOICE = 'saveapotherdocumentinvoice',
  DELETE_INVOICE = 'deleteapinvoice',
  SAVE_INVOICE_NOTE = 'saveapinvoicenote',
  DELETE_INVOICE_NOTE = 'deleteapinvoicenote',
  GET_INVOICE_HISTORY = 'getapinvoicehistory',
  SAVE_INVOICE_INFO = 'saveapinvoiceinfo',
  DELETE_INVOICE_INFO = 'deleteapinvoiceinfo',
  MAKE_RELATIONSHIP = 'makedocumentrelationship',

  // PO API Routes
  GET_ORPHAN_SMARTACCUPAY_PO = 'getorphansmartaccupaypo',
  GET_ONE_SMARTACCUPAY_PO = 'getonesmartaccupaypo',
  SAVE_SMARTACCUPAY_PO = 'savesmartaccupaypo',
  DELETE_SMARTACCUPAY_PO = 'deletesmartaccupaypo',
  SAVE_SMARTACCUPAY_OTHER_DOCUMENT_PO = 'savesmartaccupayotherdocumentpo',

  // QUOTE API Routes
  GET_ORPHAN_SMARTACCUPAY_QUOTE = 'getorphansmartaccupayquote',
  GET_ONE_SMARTACCUPAY_QUOTE = 'getonesmartaccupayquote',
  SAVE_SMARTACCUPAY_QUOTE = 'savesmartaccupayquote',
  DELETE_SMARTACCUPAY_QUOTE = 'deletesmartaccupayquote',
  SAVE_SMARTACCUPAY_OTHER_DOCUMENT_QUOTE = 'savesmartaccupayotherdocumentquote',
  GET_ALL_NEW_DOCUMENT_COUNTS = 'getAllNewDocumentCount',

  // PACKING SLIP API Routes
  GET_ORPHAN_PACKING_SLIP = 'getorphansmartaccupaypackingslip',
  GET_ONE_PACKING_SLIP = 'getonesmartaccupaypackingslip',
  SAVE_PACKING_SLIP = 'savesmartaccupaypackingslip',
  DELETE_PACKING_SLIP = 'deletesmartaccupaypackingslip',
  SAVE_OTHER_DOCUMENT_PACKING_SLIP = 'savesmartaccupayotherdocumentpackingslip',

  // Receiving Slip Api Routes
  GET_ORPHAN_AP_RECEVING_SLIP = 'getorphanreceivingslip',
  GET_ONE_AP_RECEVING_SLIP = 'getonereceivingslip',
  SAVE_AP_RECEVING_SLIP = 'savereceivingslip',
  DELETE_AP_RECEVING_SLIP = 'deletereceivingslip',
  SAVE_AP_OTHER_DOCUMENT_RECEVING_SLIP = 'saveotherdocumentreceivingslip',

  // Other document API routes
  GET_OTHER_DOCUMENT = 'getotherdocument',
  GET_ONE_OTHER_DOCUMENT = 'getoneotherdocument',
  GET_ONE_DUPLICATE_DOCUMENT = 'getoneduplicatedocument',
  DELETE_DUPLICATE_DOCUMENT = 'deleteduplicatedocument',

  //QuickBook Module
  QUICKBOOK_SAVE_INFO = "savequickbookinfo",
  QUICKBOOK_LOGOUT = "quickbookslogout",
  QUICKBOOK_ISCONNECT = "/webapi/v1/isConnecttoQBO",
  QUICKBOOK_CALLBACK = "callback",
  QUICKBOOK_REFRESH_TOKEN = 'refreshToken',
  QUICKBOOK_SYNC = 'quickbookgetdata',
  QUICKBOOK_EXPORT = 'exportquickbooksdata',
  QUICKBOOK_SYNC_INVOICE = 'quickbooksbatchinvoice',

  //save to Database
  SAVE_INVOICE_DATABASE = "/webapi/v1/portal/saveinvoicetoDB",
  SAVE_GLACCOUNTS_DATABASE = "/webapi/v1/portal/saveglaccountstoDB",
  SAVE_VENDORS_DATABASE = "/webapi/v1/portal/savevendorstoDB",

  // Document Process
  SAVE_DOCUMENT_PROCESS = 'savesmartaccupaydocumentprocess',

  // Report
  GET_INVOICE_FOR_REPORT = 'getapinvoiceforreports',

  // Header
  GET_HEADER_INVOICE_SERACH = 'getheaderapinvoicesearch',
  PORTAL_GENARATE_SUPERADMIN_OTP = "generatesuperadminotp",

  // Alerts
  GET_ALL_ALERTS = 'getallinvoicealert',
  UPDATE_ALL_ALERTS = 'updateallinvoicealert',
  UPDATE_ALERT = 'updateinvoicealert',

  // new forgot password 
  NEW_FORGET_PASSWORD_SEND_EMAIL = "sendemailUserForgotPassword",
  NEW_CHANGE_PASSWORD_WIH_EMAIL = 'userforgotpassword',
  NEW_CHANGEPASSWORD_WITH_COMPNYCODE = 'forgotpasswordwithcode',
  LOGIN_FROM_OTHER_APP = "loginfromotherapp",

  GET_INVOICE_FOR_TABLE_VENDOR = 'getapinvoiceforvendortable',

  GET_COMPANY_FOR_PAYMENT_DETAILS = "getcompanyforpaymentdetails",


  // Help cards
  GET_ALL_HELP_CARDS = "gethelpfiles",
  SEND_HELP = "helpmail",
  GET_HELP_FILE_BY_MODULE_NAME = "getHelpFileByModuleName",

  // Get All Approver User
  GET_ALL_APPROVER_USER = "getAllApproverUser",


}

export enum superAdminRoutes {
  GET_MALE_FEMALE_PRESIGN_URL = 'common/getMaleFemalePresignUrl',
  // Auth
  LOGIN = 'login',
  CHANGE_PASSWORD = 'change_password',
  FORGET_PASSWORD_SEND_EMAIL = "forgot_password",
  RESET_PASSWORD = 'rest_password',
  SEND_OTP_EMAIL = "sendemailotp",
  SAVE_ATTACHMENT = 'saveAttachmentforsuperadmin',
  GET_COMPANY_AND_USER_PROFILE = 'getCompanyAndUserProfile',
  // Superadmin
  GET_SUPERADMIN = 'getsuperadmin',
  GET_ONE_SUPERADMIN = 'getonesuperadmin',
  GET_SUPERADMIN_FOR_TABLE = 'getsuperadminfortable',
  SAVE_SUPERADMIN = 'savesuperadmin',
  UPDATE_SUPERADMIN_STATUS = 'updatesuperadmin',
  DELETE_SUPERADMIN = 'deletesuperadmin',
  SUPERADMIN_GET_HISTORY = 'getsuperadminhistoryfortable',
  SUPERADMIN_GET_LOGIN__HISTORY = 'getloginhistoryrolewisefortable',
  SUPERADMIN_SAVE_LOG_IN_HISTORY = 'save_superadmin_login_details',

  // Distributor
  GET_DISTRIBUTOR = 'getdistributor',
  GET_ONE_DISTRIBUTOR = 'getonedistributor',
  GET_DISTRIBUTOR_FOR_TABLE = 'getdistributorfortable',
  SAVE_DISTRIBUTOR = 'savedistributor',
  UPDATE_DISTRIBUTOR_STATUS = 'updatedistributor',
  DELETE_DISTRIBUTOR = 'deletedistributor',
  DISTRIBUTOR_GET_HISTORY = 'getDistributorHistoryForTable',

  // Agent
  GET_AGENT = 'getagent',
  GET_ONE_AGENT = 'getoneagent',
  GET_AGENT_FOR_TABLE = 'getagentfortable',
  SAVE_AGENT = 'saveagent',
  UPDATE_AGENT_STATUS = 'updateagent',
  DELETE_AGENT = 'deleteagent',
  AGENT_GET_HISTORY = 'getAgentHistoryForTable',

  // Client
  GET_CLIENT = 'getclient',
  GET_ONE_CLIENT = 'getoneclient',
  SAVE_CLIENT = 'saveclient',
  SAVE_CLIENT_LOGO = 'saveclientlogo',
  GET_CLIENT_FOR_TABLE = 'getclientfortable',
  UPDATE_CLIENT_STATUS = 'updateclientstatus',
  DELETE_CLIENT = 'deleteclient',
  //payment
  GET_PAYMENT_DATA_FOR_TABLE = 'getpaymenthistoryfortable',
  GET_CUSTOMER_PAYMENT_METHOD = 'getCustomerPaymentMethods',
  ADD_NEW_CUSTOMER_PAYMENT_METHOD = 'addNewPaymentMethod',
  REMOVE_CUSTOMER_PAYMENT_METHOD = 'removePaymentMethod',
  // Roles
  GET_ROLES = 'getroles',
  SAVE_ROLES = 'saveroles',
  //send invitation
  SEND_APP_INVITATION = "sendappinvitation",

  // Terms
  GET_TERM = 'getterms',
  GET_TERM_FOR_TABLE = 'gettermsfortable',
  SAVE_TERM = 'saveterms',
  DELETE_TERM = 'deleteterm',

  // Vendor Tye
  GET_VENDOR_TYPE = 'getvendortypes',
  GET_VENDOR_TYPE_FOR_TABLE = 'getvendortypesfortable',
  SAVE_VENDOR_TYPE = 'savevendortypes',
  DELETE_VENDOR_TYPE = 'deletevendortype',

  // Class Name
  GET_CLASS_NAME = 'getclassnames',
  GET_CLASS_NAME_FOR_TABLE = 'getclassnamesfortable',
  SAVE_CLASS_NAME = 'saveclassnames',
  DELETE_CLASS_NAME = 'deleteclassname',

  // Document Type
  GET_DOCUMENT_TYPE = 'getdocumenttypes',
  GET_DOCUMENT_TYPE_FOR_TABLE = 'getdocumenttypesfortable',
  SAVE_DOCUMENT_TYPE = 'savedocumenttypes',
  DELETE_DOCUMENT_TYPE = 'deletedocumenttype',

  // Department
  GET_DEPARTMENT = 'getdepartments',
  GET_DEPARTMENT_FOR_TABLE = 'getdepartmentsfortable',
  SAVE_DEPARTMENT = 'savedepartments',
  DELETE_DEPARTMENT = 'deletedepartment',

  // Job Title
  GET_JOB_TITLE = 'getjobtitles',
  GET_JOB_TITLE_FOR_TABLE = 'getjobtitlesfortable',
  SAVE_JOB_TITLE = 'savejobtitles',
  DELETE_JOB_TITLE = 'deletejobtitle',

  // Job Type
  GET_JOB_TYPE = 'getjobtypes',
  GET_JOB_TYPE_FOR_TABLE = 'getjobtypesfortable',
  SAVE_JOB_TYPE = 'savejobtypes',
  DELETE_JOB_TYPE = 'deletejobtype',

  // Relationship
  GET_RELATIONSHIP = 'getrelationships',
  GET_RELATIONSHIP_FOR_TABLE = 'getrelationshipsfortable',
  SAVE_RELATIONSHIP = 'saverelationships',
  DELETE_RELATIONSHIP = 'deleterelationship',

  // Language
  GET_LANGUAGE = 'getlanguages',
  GET_LANGUAGE_FOR_TABLE = 'getlanguagesfortable',
  SAVE_LANGUAGE = 'savelanguages',
  DELETE_LANGUAGE = 'deletelanguage',

  // Send Update Alert
  SEND_UPDATE_ALERT = 'sendupdatealert',

  // GIF
  GET_GIF = 'getgif',
  SAVE_GIF = 'savegif',


  // Tenants
  GET_TENANTS = 'gettenants',
  GET_ONE_TENANT = 'getonetenant',
  VERIFY_SMTP = 'verifysmtp',
  SAVE_SMTP = 'savesmtp',
  COMPANY_USAGE = 'companyusage',
  GET_API_COUNT = 'getapicount',
  VERIFY_IMAP = 'verifyIMAP',
  GET_USAGE_INVOICE_LIST = 'getUsageInvoiceList',
  GET_USAGE_DUPLICATE_INVOICE_LIST = 'getDuplicateInvoiceDocumentsList',

  // Mailbox Monitor
  GET_MAILBOX_MONITOR = 'getmailboxmonitorsuperadmin',
  SAVE_MAILBOX_MONITOR = 'savemailboxmonitorsuperadmin',

  //DASHBOARD
  GET_SUPERADMIN_DASHBOARD_COUNT = 'getsuperadmincount',
  GET_SUPERADMIN_DASHBOARD_CLIENT_INVOICE_DOCUMENT_CHART = 'getdashboardclientinvoicedocumentchart',
  GET_CLIENT_MONTHLY_INVOICE_DOCUMENT_CHART = 'getdashboardmonthlyinvoicedocumentchart',

  //SMTP
  GET_SUPERADMIN_SMTP = 'superadminsmtp',
  VERIFY_SUPERADMIN_SMTP = 'superadminverifySMTP',
  SAVE_SUPERADMIN_SMTP = 'superadminsavesmtp',

  //stripe plan
  GET_PLAN_FOR_TABLE = 'getpriceplanfortable',
  UPDATE_PLAN_STATUS = 'activeinactivepriceplan',
  GET_ONE_PRICE_PLAN = "getonepriceplan",
  DELETE_PRICE_PLAN = "deletepriceplan",
  SAVE_PRICE_PLAN = "savepriceplan",

  //checkemail
  CHECK_COMPANY_NAME = "check_client_name_exist_or_not",
  CHECK_EMAIL = "chheckclientemailexistornot",
  CHECK_IN = "checkclienteinexistornot",
  SAVE_REGISTRATION_FORM = "registercompany",
  GET_PLAN_DETAILS = "getonepriceplanfromname",
  GET_COMPANY_FOR_PAYMENT_DETAILS = "getcompanyforpaymentdetails",
  cancel_subscription = "cancel_subscription",
  renew_subscription = "renew_subscription",
  gat_all_priceplan = "gatallpriceplan",
  UPDATE_CARD_DETAILS = "updatecarddetails",
  reSendCompanyRegistrationMail = "re_send_company_registration_mail",

  //Stripe API
  CREATE_PAYMENT = "create_payment_intent",
  GET_CARD_DETAILS = "get_stripe_payment_details",

  SAVE_TRIAL_SETTING = 'savetrialcompanysetting',
  GET_TRIAL_SETTING = 'getonetrialcompanysetting',

  //Ticket
  GET_TICKET_FOR_TABLE = 'getticketfortable',
  TICKET_SAVE = 'addticketsystem',
  TICKET_GET_ALL_COMPANY = "getallcompany",
  TICKET_GET_ALL_COMPANY_USER_LIST = "getcompanyuserliist",
  GET_ONE_TICKET = "getoneticket",
  GET_TICKET_COUNT = "countStatus",
  SUPERADMIN_ATTACHMENT = "superadminAttechment",
  SUPERADMIN_TICKET_ATTACHMENT = "saveAttechmentforticket",

  //coupon 
  GET_COUPONS_FOR_TABLE = 'getcouponsfortable',
  SAVE_COUPONS = "savecoupons",
  DELETE_COUPONS = "deletecoupons",
  GET_ALL_COUPONS = "getcoupons",
  GET_ONE_COUPONS = "getonecoupons",

  SUPPORT_OTP = 'submitsupportotp',

}
